type CostCenterCustomDataType = Record<string, string | number | string[]>;

const getCostCenterCustomFieldKeys = (
  costCenterCustomData?: CostCenterCustomDataType,
): string[] => {
  const customFieldKeys = costCenterCustomData
    ? Object.keys(costCenterCustomData)
    : [];

  if (!costCenterCustomData || !customFieldKeys.length) {
    return [];
  }

  return customFieldKeys.filter((customKey) => {
    const customValue = costCenterCustomData[customKey];

    return (
      customValue !== '' &&
      (!Array.isArray(customValue) || customValue.length > 0) &&
      customValue !== 'false'
    );
  });
};

export const hasCustomFieldsMarkerForCostCenter = (
  costCenterCustomData?: CostCenterCustomDataType,
): boolean => {
  const keysWithAcceptableValues =
    getCostCenterCustomFieldKeys(costCenterCustomData);

  return keysWithAcceptableValues.length > 0;
};
